import { render, staticRenderFns } from "./iframe-left.vue?vue&type=template&id=1d2162b4&scoped=true"
import script from "./iframe-left.vue?vue&type=script&lang=js"
export * from "./iframe-left.vue?vue&type=script&lang=js"
import style0 from "./iframe-left.vue?vue&type=style&index=0&id=1d2162b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2162b4",
  null
  
)

export default component.exports